import styled, { css } from 'styled-components/macro';
import {
  ModelListDiv,
  ModelListTable,
  ModelListTd
} from '../../components/ModelListStyles';
import { Link } from 'react-router-dom';

// show
// export const tableSpacingMobile = 3;
// export const tableSpacingDevice = 3;
// export const tableSpacingDesktop = 4;
// export const tableSpacingLgDesktop = 6;

export const TableRowAlignmentDiv = styled.div`
  height: 0.9rem;
`;

export const SubtitleP = styled.p`
  color: ${props => props.theme[props.color]};
  font-size: 1.2rem;
  ${props =>
    props.firstCapital &&
    css`
      &::first-letter {
        text-transform: uppercase;
      }
    `}
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const SpacerDiv = styled.div`
  margin-top: 3.3rem;
`;

export const CustomModelListTd = styled(ModelListTd)`
  /* padding: 0.5rem 5px; */

  height: 54px;
  padding-top: 10px;
  padding-bottom: 10px;
  ${props =>
    props.bold &&
    css`
      font-weight: 500;
    `}
`;

export const CustomShowModelListDiv = styled(ModelListDiv)`
  padding: 5rem 0;
  @media screen and (min-width: 768px) {
    padding: 7rem 0;
  }
  @media screen and (min-width: 1440px) {
    padding: 8rem 0;
  }
  position: relative;
  ${props =>
    !props.hideBorderTop &&
    css`
      border-top: black solid 2px;
    `}
`;

const close = css`
  cursor: pointer;
  position: absolute;
  display: block;
  top: 72px;
  right: 78px;
  > svg {
    width: 22px;
    height: 22px;
  }
  fill: ${props => props.theme.dustierGray};
  :hover {
    fill: black;
  }
  @media screen and (min-width: 1440px) {
    top: 32px;
    right: 42px;
  }
  @media screen and (max-width: 1439px) {
    top: 34px;
    right: 42px;
  }
  @media screen and (max-width: 1023px) {
    top: 38px;
    right: 43px;
  }
  @media screen and (max-width: 767px) {
    top: 42px;
    right: 35px;
  }
  @media screen and (max-width: 374px) {
    top: 40px;
    right: 41px;
  }
`;

export const XIconWrapDiv = styled.div`
  ${close}
`;

export const XIconWrapLink = styled(Link)`
  ${close}
`;

export const CustomModelListTable = styled(ModelListTable)`
  ${props =>
    props.hasPerPageFilter &&
    css`
      margin-bottom: 1.1rem;
      @media screen and (min-width: 768px) {
        margin-bottom: 1.8rem;
      }
    `}
`;
